import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-info',
  templateUrl: './loading-info.component.html'
})
export class LoadingInfoComponent {

  @Input() loading: boolean;
  @Input() mensaje: string;

  constructor() { }
}
